import React from 'react';
import { useSelector } from 'react-redux';

import { getMarket } from '../selectors';
import { getAddressFormat } from '../utils/l10n';

type Props = {
  market?: string;
  country: string;
  postcode: string;
  address: string;
};

function getL10nAddress(props: Props) {
  const market = props?.market || '';
  // Removing { } from the address format
  const addressFormat = getAddressFormat(market).replace(/[{}]/g, '').split(', ');
  return addressFormat.reduce((address, key) => {
    const value = props[key as keyof Props];
    if (value) {
      return address ? `${address}, ${value}` : value;
    }
    return address;
  }, '');
}

function L10nAddress(props: Props) {
  const marketFromStore = useSelector(getMarket)?.marketCode || '';
  return (
    <span>
      {getL10nAddress({
        ...props,
        market: props.market || marketFromStore,
      })}
    </span>
  );
}

export default L10nAddress;
